const comprobanteRetencionIVATemplateHtml = `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Comprobante de Retención</title>
    <style>
        @page {
            size: A4 landscape;
            margin: 10mm;
        }

        @media print {
            body {
                background-color: #fff !important;
                margin: 0;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .container {
                max-width: 100% !important;
                padding: 0 !important;
                margin: 0 !important;
            }
            th {
                background-color: #a4c2f4 !important;
            }
            .subject-val, .net-pay-val, th, td {
                border: 1px solid #000 !important;
            }
            input {
                border: none !important;
                background: transparent !important;
            }
            .no-print {
                display: none !important;
            }
        }

        body {
            font-family: Arial, sans-serif;
            font-size: 10px;
            color: #000;
            margin: 0;
            padding: 20px;
            background-color: #f0f0f0;
        }
        .container {
            width: 100%;
            max-width: 1400px;
            margin: 0 auto;
            background-color: #fff;
            padding: 30px;
            box-sizing: border-box;
        }

        .header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        .header-left {
            width: 75%;
            padding-right: 20px;
        }
        .title-container {
            text-align: center;
        }
        .title-container h1 {
            font-size: 16px;
            margin: 0 0 10px 0;
            font-weight: bold;
        }
        .legal-text {
            font-size: 9px;
            margin: 0 0 15px 0;
            text-align: left;
            line-height: 1.2;
            font-weight: bold;
        }
        .header-info-row {
            display: flex;
            justify-content: flex-start;
            gap: 100px;
            font-size: 10px;
            font-weight: bold;
        }
        .header-info-col {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 3px;
        }
        .header-info-col span.val {
            font-weight: normal;
        }
        .header-info-col.periodo {
            flex-direction: row;
            gap: 30px;
            align-items: center;
        }
        .header-info-col.periodo div {
            display: flex;
            gap: 5px;
        }

        .logo-container {
            width: 250px;
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
            padding-left: 10px;
            border: none;
        }
        .logo-container img {
            max-width: 100%;
            height: auto;
        }

        .info-section {
            display: grid;
            grid-template-columns: 380px 400px 1fr;
            margin-bottom: 15px;
            align-items: flex-start;
            font-size: 10px;
        }
        .labels-col {
            display: flex;
            flex-direction: column;
            gap: 8px;
            font-weight: bold;
        }
        .values-col {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
        .subject-val {
            border: 1px solid #000;
            padding: 1px 4px;
            display: inline-block;
            width: 100%;
            box-sizing: border-box;
        }
        .address-col {
            padding-left: 20px;
        }
        .address-col strong {
            display: block;
            margin-bottom: 5px;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 9px;
            text-align: center;
            margin-bottom: 5px;
        }
        th, td {
            border: 1px solid #000;
            padding: 4px 2px;
        }
        th {
            background-color: #a4c2f4;
            font-weight: bold;
        }

        th:nth-child(1) { width: 40px; }
        th:nth-child(2) { width: 60px; }
        th:nth-child(3) { width: 80px; }
        th:nth-child(4) { width: 80px; }
        th:nth-child(5) { width: 80px; }
        th:nth-child(10) { width: 80px; }
        th:nth-child(12) { width: 80px; }
        th:nth-child(14) { width: 70px; }
        th:nth-child(16) { width: 70px; }

        .empty-row td {
            height: 14px;
        }

        .td-filled {
            font-weight: bold;
            font-size: 9px;
            padding: 4px 2px;
        }

        .totals-table {
            width: 100%;
            border-collapse: collapse;
            border: none;
        }
        .totals-table td {
            border: none;
            padding: 2px;
            text-align: center;
            height: 16px;
        }
        .totals-table td.boxed {
            border: 1px solid #000;
        }

        .net-pay-container {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 5px;
            gap: 10px;
            font-size: 10px;
        }
        .net-pay-val {
            border: 1px solid #000;
            padding: 0px 10px;
            font-weight: normal;
            min-width: 120px;
            text-align: center;
            font-weight: bold;
            font-size: 11px;
        }

        .footer {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: 60px;
            padding: 0 50px;
        }
        .signature-box {
            width: 250px;
            text-align: center;
            border-top: 1px solid #000;
            padding-top: 5px;
            font-size: 10px;
        }
        .date-box {
            border: 1px solid #000;
            display: flex;
            font-size: 9px;
        }
        .date-box .label {
            padding: 4px 10px;
            border-right: 1px solid #000;
        }
        .date-box .val {
            padding: 4px 20px;
        }

        .txt-right { text-align: right; }
        .txt-left { text-align: left; }

        input.tbl-input {
            width: 95%;
            box-sizing: border-box;
            text-align: center;
            border: none;
            font-size: 9px;
            font-family: Arial, sans-serif;
            background: transparent;
            outline: none;
        }
        input.tbl-input:focus {
            background: #f0f8ff;
            border-bottom: 1px solid #4a90d9;
        }

        .action-bar {
            text-align: right;
            margin-bottom: 15px;
            padding: 8px 12px;
            background: #f8f9fa;
            border-radius: 4px;
            display: flex;
            justify-content: flex-end;
            gap: 8px;
        }
        .btn {
            padding: 6px 12px;
            border: 1px solid #999;
            border-radius: 3px;
            cursor: pointer;
            font-family: Arial, sans-serif;
            font-weight: bold;
            font-size: 11px;
        }
        .btn-print { background: #fff; color: #000; }
        .btn-download { background: #fff; color: #000; }
    </style>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
</head>
<body>
    <div class="action-bar no-print" id="action-bar">
        <button class="btn btn-print" onclick="window.print()">Imprimir</button>
        <button class="btn btn-download" onclick="window.descargarPDF()">Descargar PDF</button>
    </div>

    <div class="container" id="retencion-document">

        <div class="header">
            <div class="header-left">
                <div class="title-container">
                    <h1>COMPROBANTE DE RETENCION DEL IMPUESTO AL VALOR AGREGADO</h1>
                </div>
                <div class="legal-text">
                    (Ley IVA Art. 11: Serán responsables del pago del impuesto en calidad de agentes de retencion, los compradores o adquiridos de determinados bienes muebles y los receptores de ciertos servicios, a quienes la Administración Tributaria designe como tal:
                </div>
                <div class="header-info-row">
                    <div class="header-info-col">
                        <span>Fecha de emision</span>
                        <span class="val" id="fecha-emision">—</span>
                    </div>
                    <div class="header-info-col periodo">
                        <span>Periodo Fiscal:</span>
                        <div><span>Año:</span><span class="val" id="periodo-anio">—</span></div>
                        <div><span>Mes:</span><span class="val" id="periodo-mes">—</span></div>
                    </div>
                    <div class="header-info-col">
                        <span>Nro<br>Comprobante:</span>
                    </div>
                    <div class="header-info-col" style="justify-content: flex-end;">
                        <span class="val" id="nro-comprobante">—</span>
                    </div>
                </div>
            </div>
            <div class="logo-container">
                <img id="company-logo" src="/Logo GAMAN.png" alt="Electro Soluciones Gaman C.A.">
            </div>
        </div>

        <div class="info-section">
            <div class="labels-col">
                <div>NOMBRE O RAZON SOCIAL DE AGENTE DE RETENCION:</div>
                <div>REGISTRO DE INFORMACION FISCAL DEL AGENTE DE RETENCION:</div>
                <div>NOMBRE O RAZON SOCIAL DEL SUJETO RETENIDO:</div>
                <div>REGISTRO DE INFORMACION FISCAL DEL SUJETO RETENIDO</div>
            </div>
            <div class="values-col">
                <div id="agente-nombre">"ELECTROSOLUCIONES GAMAN C.A"</div>
                <div id="agente-rif" style="padding-left: 80px;">J-411293229</div>
                <div class="subject-val" id="sujeto-nombre">—</div>
                <div class="subject-val" id="sujeto-rif">—</div>
            </div>
            <div class="address-col">
                <strong>DIRECCION FISCAL DEL AGENTE DE RETENCION:</strong>
                <div id="agente-direccion">CALLE ROSCIO EDIF RESIDENCIAS MARIANA PISO PB LOCAL 3 SECTOR CENTRO SAN JUAN DE LOS MORROS GUARICO ZONA POSTAL 2301"</div>
            </div>
        </div>

        <table>
            <thead>
                <tr>
                    <th rowspan="2">Operación<br>Nro</th>
                    <th rowspan="2">Fecha de la<br>Factura</th>
                    <th rowspan="2">Numero de<br>Comprob.</th>
                    <th rowspan="2">Numero de factura</th>
                    <th rowspan="2">Numero control<br>de factura</th>
                    <th rowspan="2">Numero nota debito</th>
                    <th rowspan="2">Numero nota<br>credito</th>
                    <th rowspan="2">Tipo de<br>Transacc.</th>
                    <th rowspan="2">Numero de<br>factura afectada</th>
                    <th rowspan="2">Total Compras<br>incluyendo el<br>IVA</th>
                    <th rowspan="2">Monto<br>exento</th>
                    <th colspan="5">COMPRAS INTERNAS O IMPORTACIONES</th>
                </tr>
                <tr>
                    <th style="width: 80px;">Base imponible</th>
                    <th>% Alic.</th>
                    <th>Impuesto IVA</th>
                    <th>% RET.</th>
                    <th>IVA RETENIDO</th>
                </tr>
            </thead>
            <tbody id="operaciones-body">
                <tr class="empty-row"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr class="empty-row"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr class="empty-row"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr class="empty-row"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr class="empty-row"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            </tbody>
        </table>

        <table class="totals-table">
            <tr>
                <td style="width: 40px;"></td>
                <td style="width: 60px;"></td>
                <td style="width: 80px;"></td>
                <td style="width: 80px;"></td>
                <td style="width: 80px;"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="boxed" style="width: 80px;" id="total-compras-iva-total">—</td>
                <td></td>
                <td class="boxed" style="width: 60px;" id="base-imponible-total">—</td>
                <td></td>
                <td class="boxed" style="width: 60px;" id="impuesto-iva-total">—</td>
                <td></td>
                <td class="boxed" style="width: 60px;" id="iva-retenido-total">—</td>
            </tr>
        </table>

        <div class="net-pay-container">
            <span>NETO A PAGAR:</span>
            <div class="net-pay-val" id="neto-pagar">—</div>
        </div>

        <div class="footer">
            <div class="signature-box">
                FIRMA Y SELLO<br>AGENTE DE RETENCIÓN
            </div>

            <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 40px;">
                <div class="signature-box">
                    FIRMA Y SELLO<br>SUJETO RETENIDO
                </div>
                <div class="date-box">
                    <div class="label">FECHA DE ENTREGA:</div>
                    <div class="val" id="fecha-entrega">—</div>
                </div>
            </div>
        </div>

    </div>

    <script>
        window.renderComprobanteRetencionIVA = function(data) {
            var setText = function(id, value) {
                var el = document.getElementById(id);
                if (el && value !== undefined && value !== null && value !== '') {
                    el.textContent = value;
                }
            };

            setText('fecha-emision', data.comprobante && data.comprobante.fechaEmision);
            setText('periodo-anio', data.comprobante && data.comprobante.periodoAnio);
            setText('periodo-mes', data.comprobante && data.comprobante.periodoMes);
            setText('nro-comprobante', data.comprobante && (data.comprobante.nroComprobante || data.comprobante.numero));

            setText('agente-nombre', data.agente && data.agente.nombre);
            setText('agente-rif', data.agente && data.agente.rif);
            setText('agente-direccion', data.agente && data.agente.direccion);

            setText('sujeto-nombre', data.sujetoRetenido && data.sujetoRetenido.nombre);
            setText('sujeto-rif', data.sujetoRetenido && data.sujetoRetenido.rif);

            var tbody = document.getElementById('operaciones-body');
            if (tbody) {
                tbody.innerHTML = '';
                var ops = data.operaciones && Array.isArray(data.operaciones) ? data.operaciones : [];

                var hasDataFields = ['nro', 'fecha', 'numeroComprobante', 'numeroFactura', 'totalComprasIVA', 'baseImponible', 'porcentajeAlicuota', 'impuestoIVA', 'porcentajeRetencion', 'ivaRetenido'];
                var noDataFields = ['numeroControl', 'numeroNotaDebito', 'numeroNotaCredito', 'tipoTransaccion', 'numeroFacturaAfectada', 'montoExento'];

                for (var i = 0; i < ops.length; i++) {
                    var op = ops[i];
                    var tr = document.createElement('tr');

                    var cells = [
                        op.nro || (i + 1),
                        op.fecha || '',
                        op.numeroComprobante || '',
                        op.numeroFactura || '',
                        op.numeroControl || null,
                        null,
                        null,
                        op.tipoTransaccion || null,
                        op.facturaAfectada || null,
                        op.totalComprasIVA || '',
                        op.montoExento || null,
                        op.baseImponible || '',
                        op.porcentajeAlicuota || '',
                        op.impuestoIVA || '',
                        op.porcentajeRetencion || '',
                        op.ivaRetenido || ''
                    ];

                    var html = '';
                    for (var j = 0; j < cells.length; j++) {
                        if (cells[j] !== null && cells[j] !== undefined && cells[j] !== '') {
                            var alignClass = '';
                            if (j >= 9 && j !== 12 && j !== 14) {
                                alignClass = ' style="text-align:right;"';
                            }
                            html += '<td class="td-filled"' + alignClass + '>' + cells[j] + '</td>';
                        } else {
                            var inputName = '';
                            var inputType = 'text';
                            var inputStep = '';
                            switch (j) {
                                case 0: inputName = 'operacion_nro_' + i; break;
                                case 1: inputName = 'fecha_factura_' + i; break;
                                case 2: inputName = 'nro_comprobante_' + i; break;
                                case 3: inputName = 'nro_factura_' + i; break;
                                case 4: inputName = 'nro_control_' + i; break;
                                case 5: inputName = 'nota_debito_' + i; break;
                                case 6: inputName = 'nota_credito_' + i; break;
                                case 7: inputName = 'tipo_transaccion_' + i; break;
                                case 8: inputName = 'factura_afectada_' + i; break;
                                case 9: inputName = 'total_compras_iva_' + i; inputType = 'number'; inputStep = '0.01'; break;
                                case 10: inputName = 'monto_exento_' + i; break;
                                case 11: inputName = 'base_imponible_' + i; inputType = 'number'; inputStep = '0.01'; break;
                                case 12: inputName = 'alicuota_' + i; break;
                                case 13: inputName = 'impuesto_iva_' + i; inputType = 'number'; inputStep = '0.01'; break;
                                case 14: inputName = 'porcentaje_ret_' + i; break;
                                case 15: inputName = 'iva_retenido_' + i; inputType = 'number'; inputStep = '0.01'; break;
                            }
                            var extraAttrs = inputStep ? ' step="' + inputStep + '"' : '';
                            html += '<td><input type="' + inputType + '"' + extraAttrs + ' name="' + inputName + '" class="tbl-input" placeholder="—"></td>';
                        }
                    }
                    tr.innerHTML = html;
                    tbody.appendChild(tr);
                }

                var maxRows = Math.max(5, ops.length + 2);
                for (var k = ops.length; k < maxRows; k++) {
                    var emptyTr = document.createElement('tr');
                    emptyTr.className = 'empty-row';
                    var emptyHtml = '';
                    for (var m = 0; m < 16; m++) {
                        emptyHtml += '<td></td>';
                    }
                    emptyTr.innerHTML = emptyHtml;
                    tbody.appendChild(emptyTr);
                }
            }

            var fmt = function(val) {
                if (val === undefined || val === null || val === '') return '';
                if (typeof val === 'number') {
                    return val.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
                return val;
            };

            setText('total-compras-iva-total', fmt(data.totales && data.totales.totalComprasIVA));
            setText('base-imponible-total', fmt(data.totales && data.totales.baseImponible));
            setText('impuesto-iva-total', fmt(data.totales && data.totales.impuestoIVA));
            setText('iva-retenido-total', fmt(data.totales && data.totales.ivaRetenido));

            setText('neto-pagar', fmt(data.footer && data.footer.netoAPagar));
            setText('fecha-entrega', data.footer && data.footer.fechaEntrega);

            if (data.comprobante && data.comprobante.numero) {
                document.title = 'Comprobante Retención IVA - ' + data.comprobante.numero;
            }

            if (window !== window.top) {
                var actionBar = document.getElementById('action-bar');
                if (actionBar) actionBar.style.display = 'none';
            }
        };

        window.descargarPDF = function() {
            var element = document.getElementById('retencion-document');
            var opt = {
                margin: [0.4, 0.4, 0.4, 0.4],
                filename: (document.title || 'Comprobante') + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
            };

            if (typeof html2pdf !== 'undefined') {
                html2pdf().set(opt).from(element).save();
            } else {
                alert('La librería para generar PDF no está cargada.');
            }
        };
    </script>
</body>
</html>`;

export default comprobanteRetencionIVATemplateHtml;
